export const setExperimentsReady = (value) => ({
  type: 'SET_EXPERIMENTS_READY',
  value,
});

export const setExperimentsDisabled = (value) => ({
  type: 'SET_EXPERIMENTS_DISABLED',
  value,
});
